import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ExistingAddAccountModel } from "@theHescoBlueprint/ApiModels";
import { addAccountExistingCustomer as addAccountExistingCustomerApi } from "@theHescoBlueprint/Services/CustomAddAccountService";
import { CustomApiHandler } from "@theHescoBlueprint/Store/CustomHandlerCreator";

type customAddAccountParam = {
    addCustomAddAccountParams: ExistingAddAccountModel;
} & HasOnSuccess &
    HasOnError<string>;

type HandlerType = CustomApiHandler<customAddAccountParam, ServiceResult<ExistingAddAccountModel>>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await addAccountExistingCustomerApi(props.parameter.addCustomAddAccountParams);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const customAddAccount = createHandlerChainRunner(chain, "addAccountExistingCustomer");
export default customAddAccount;
